'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DesktopMenu = exports.CLASS_ACTIVE = exports.CLASS_VISIBLE = exports.CLASS_SUBMENU_OPEN = exports.CLASS_MENU_OPEN = exports.VENDOR_REVIEVE_BUTTON = exports.REVIEVE_BUTTON = exports.DESKTOP_LINK_ITEM = exports.DESKTOP_MENU_SUBMENU = exports.DESKTOP_MENU_TRIGGER = exports.DESKTOP_MENU_CLOSE = exports.DESKTOP_MENU_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _pcSlateTools = require('@process-creative/pc-slate-tools');

var _reveiveConfig = require('./../../tools/reveive-config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DESKTOP_MENU_SELECTOR = exports.DESKTOP_MENU_SELECTOR = '[data-desktop-menu]'; /*
                                                                                    *  Desktop Menu
                                                                                    *    Scripts the desktop meganav menu
                                                                                    *
                                                                                    *  Version:
                                                                                    *    1.0.0 - 2020/02/24
                                                                                    */

var DESKTOP_MENU_CLOSE = exports.DESKTOP_MENU_CLOSE = '[data-desktop-menu-close]';
var DESKTOP_MENU_TRIGGER = exports.DESKTOP_MENU_TRIGGER = 'data-desktop-menu-trigger';
var DESKTOP_MENU_SUBMENU = exports.DESKTOP_MENU_SUBMENU = 'data-desktop-menu-submenu';
var DESKTOP_LINK_ITEM = exports.DESKTOP_LINK_ITEM = '[data-link-item]';
var REVIEVE_BUTTON = exports.REVIEVE_BUTTON = '[data-revieve-button]';
var VENDOR_REVIEVE_BUTTON = exports.VENDOR_REVIEVE_BUTTON = '#revieve-button';

var CLASS_MENU_OPEN = exports.CLASS_MENU_OPEN = 'is-menu-open';
var CLASS_SUBMENU_OPEN = exports.CLASS_SUBMENU_OPEN = 'is-submenu-open';
var CLASS_VISIBLE = exports.CLASS_VISIBLE = 'is-visible';
var CLASS_ACTIVE = exports.CLASS_ACTIVE = 'is-active';
var CLASS_FIXED = 'is-fixed';

var DesktopMenu = exports.DesktopMenu = function () {
  function DesktopMenu(template, container) {
    var _this = this;

    (0, _classCallCheck3.default)(this, DesktopMenu);

    this.container = container;
    this.template = template;

    this.body = $('body');

    container.on('mouseenter', function () {
      return _this.onMouseEnter();
    });
    container.on('mouseleave', function () {
      return _this.onMouseLeave();
    });

    var seconds = 0;
    this.checkModal = setInterval(function () {
      _this.vendorRevieve = $(VENDOR_REVIEVE_BUTTON);
      if (_this.vendorRevieve.length > 0) clearInterval(_this.checkModal);

      // Remove setInterval if > 1 min
      seconds += 1;
      if (seconds > 60) clearInterval(_this.checkModal);

      // Hide reveive vendor button
      _this.vendorRevieve.css('display', 'none');

      // Click event listener for custom revieve button
      $(document).on('click touchend', REVIEVE_BUTTON, function (e) {
        e.preventDefault();
        e.stopPropagation();
        _this.vendorRevieve[0] && _this.vendorRevieve[0].click();
      });
    }, 200);

    // 3rd party facial recognition app Revieve
    (0, _reveiveConfig.reveiveConfig)();
  }

  (0, _createClass3.default)(DesktopMenu, [{
    key: 'onMouseEnter',
    value: function onMouseEnter() {
      this.body.addClass(CLASS_MENU_OPEN);
    }
  }, {
    key: 'onMouseLeave',
    value: function onMouseLeave() {
      this.body.removeClass(CLASS_MENU_OPEN);
    }
  }]);
  return DesktopMenu;
}();